import { render, staticRenderFns } from "./_MenuOptionsMore.vue?vue&type=template&id=95941988&"
import script from "./_MenuOptionsMore.vue?vue&type=script&lang=js&"
export * from "./_MenuOptionsMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports